import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavingsOpportunityLeft = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 66,
	viewBox: "0 0 54 66",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6448_23335)",
		children: [/* @__PURE__ */ _jsx("rect", {
			opacity: .15,
			width: 54,
			height: 66,
			fill: "#12875E"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_6448_23335)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_6448_23335",
					style: { maskType: "alpha" },
					maskUnits: "userSpaceOnUse",
					x: 3,
					y: 22,
					width: 42,
					height: 42,
					children: /* @__PURE__ */ _jsx("rect", {
						x: 3,
						y: 22.957,
						width: 41.043,
						height: 41.043,
						fill: "#D9D9D9"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask0_6448_23335)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M13.2604 57.1589C11.3793 57.1589 9.76891 56.4891 8.42932 55.1495C7.08972 53.8099 6.41992 52.1995 6.41992 50.3184V36.6374C6.41992 34.7562 7.08972 33.1459 8.42932 31.8063C9.76891 30.4667 11.3793 29.7969 13.2604 29.7969H33.7819C35.663 29.7969 37.2734 30.4667 38.613 31.8063C39.9526 33.1459 40.6224 34.7562 40.6224 36.6374V50.3184C40.6224 52.1995 39.9526 53.8099 38.613 55.1495C37.2734 56.4891 35.663 57.1589 33.7819 57.1589H13.2604ZM13.2604 36.6374H33.7819C34.4089 36.6374 35.0075 36.7086 35.5775 36.8511C36.1476 36.9936 36.6891 37.2217 37.2021 37.5352V36.6374C37.2021 35.6968 36.8672 34.8916 36.1975 34.2218C35.5277 33.552 34.7225 33.2171 33.7819 33.2171H13.2604C12.3198 33.2171 11.5147 33.552 10.8449 34.2218C10.1751 34.8916 9.84017 35.6968 9.84017 36.6374V37.5352C10.3532 37.2217 10.8947 36.9936 11.4648 36.8511C12.0348 36.7086 12.6334 36.6374 13.2604 36.6374ZM10.0967 42.1953L29.1218 46.8126C29.3783 46.8696 29.6349 46.8696 29.8914 46.8126C30.1479 46.7556 30.3902 46.6416 30.6182 46.4706L36.5609 41.5112C36.2473 41.0837 35.8483 40.7345 35.3638 40.4638C34.8792 40.193 34.3519 40.0576 33.7819 40.0576H13.2604C12.5194 40.0576 11.8709 40.25 11.3152 40.6348C10.7594 41.0196 10.3532 41.5397 10.0967 42.1953Z",
						fill: "#12875E"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .15,
					d: "M32.1211 15C11.943 14.9994 9.05645 23.0424 8.67557 26.5056C8.6152 27.0546 9.06478 27.5 9.61706 27.5H32.1211V15Z",
					fill: "#12875E"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 27,
					y: 14,
					width: 21,
					height: 14,
					rx: 7,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask1_6448_23335",
					style: { maskType: "alpha" },
					maskUnits: "userSpaceOnUse",
					x: 25,
					y: 9,
					width: 25,
					height: 24,
					children: /* @__PURE__ */ _jsx("rect", {
						x: 25.6211,
						y: 9,
						width: 24,
						height: 24,
						fill: "#D9D9D9"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask1_6448_23335)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M37.3711 25H38.0961V24.2C38.5628 24.1333 38.9586 23.9417 39.2836 23.625C39.6086 23.3083 39.7711 22.9 39.7711 22.4C39.7711 21.9667 39.6044 21.6042 39.2711 21.3125C38.9378 21.0208 38.5544 20.7833 38.1211 20.6V18.75C38.2878 18.8 38.4253 18.8833 38.5336 19C38.6419 19.1167 38.7211 19.2583 38.7711 19.425L39.6711 19.05C39.5544 18.7 39.3544 18.4208 39.0711 18.2125C38.7878 18.0042 38.4711 17.8667 38.1211 17.8V17H37.3711V17.775C36.9044 17.825 36.5086 17.9958 36.1836 18.2875C35.8586 18.5792 35.6961 18.9667 35.6961 19.45C35.6961 19.9 35.8669 20.275 36.2086 20.575C36.5503 20.875 36.9378 21.1167 37.3711 21.3V23.275C37.1044 23.1917 36.8794 23.05 36.6961 22.85C36.5128 22.65 36.3878 22.4167 36.3211 22.15L35.4461 22.525C35.5794 22.9917 35.8128 23.375 36.1461 23.675C36.4794 23.975 36.8878 24.1583 37.3711 24.225V25ZM38.1211 23.25V21.6C38.3044 21.6833 38.4669 21.7833 38.6086 21.9C38.7503 22.0167 38.8211 22.1917 38.8211 22.425C38.8211 22.6917 38.7544 22.8792 38.6211 22.9875C38.4878 23.0958 38.3211 23.1833 38.1211 23.25ZM37.3711 20.275C37.1878 20.1917 37.0211 20.0917 36.8711 19.975C36.7211 19.8583 36.6461 19.6833 36.6461 19.45C36.6461 19.2167 36.7211 19.0458 36.8711 18.9375C37.0211 18.8292 37.1878 18.7583 37.3711 18.725V20.275ZM33.6211 28C31.6711 28 30.0169 27.3208 28.6586 25.9625C27.3003 24.6042 26.6211 22.95 26.6211 21C26.6211 19.05 27.3003 17.3958 28.6586 16.0375C30.0169 14.6792 31.6711 14 33.6211 14H41.6211C43.5711 14 45.2253 14.6792 46.5836 16.0375C47.9419 17.3958 48.6211 19.05 48.6211 21C48.6211 22.95 47.9419 24.6042 46.5836 25.9625C45.2253 27.3208 43.5711 28 41.6211 28H33.6211ZM33.6211 26H41.6211C43.0044 26 44.1836 25.5125 45.1586 24.5375C46.1336 23.5625 46.6211 22.3833 46.6211 21C46.6211 19.6167 46.1336 18.4375 45.1586 17.4625C44.1836 16.4875 43.0044 16 41.6211 16H33.6211C32.2378 16 31.0586 16.4875 30.0836 17.4625C29.1086 18.4375 28.6211 19.6167 28.6211 21C28.6211 22.3833 29.1086 23.5625 30.0836 24.5375C31.0586 25.5125 32.2378 26 33.6211 26Z",
						fill: "#12875E"
					})
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6448_23335",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 54,
			height: 66,
			rx: 6,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_6448_23335",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 46,
			height: 46,
			fill: "white",
			transform: "translate(4 12)"
		})
	})] })]
});
const ForwardRef = forwardRef(SvgSavingsOpportunityLeft);
export { ForwardRef as ReactComponent };
